import { Box, Button, Theme, Typography } from '@mui/material'
import { SuccessIcon } from '../../assets/SvgIcons'
import { USER_ROLES } from '../../utils/constant';
import { useHistory } from 'react-router';

export default function BseTradeSuccess(): JSX.Element {

    const history = useHistory();
    return (
        <Box sx={(theme: Theme) => ({
            width: '100%',
            height: '100vh',
            backgroundColor: theme.palette.common.white,
            padding: '25px 30px 45px 30px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        })}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                < SuccessIcon />
            </Box>
            <Typography variant='h1' color={'text.primary'} textAlign={'center'} mb={4}>
                BSE Trade
            </Typography>

            <Typography variant='body_600' color={'text.primary'} textAlign={'center'} mb={4}>
                Order has been placed successfully
            </Typography>

            <Typography variant='body_500' color={'text.primary'} textAlign={'center'} mb={4}>
                Please check orders section for further updates.
            </Typography>

            <Button variant='contained' size='small' onClick={() => history.replace('/investor-dashboard')}>
                <Typography>
                    Go To Dashboard
                </Typography>
            </Button>
        </Box>
    )
}
